import { render, staticRenderFns } from "./OfSelection.vue?vue&type=template&id=325aa0f2&scoped=true"
import script from "./OfSelection.vue?vue&type=script&lang=js"
export * from "./OfSelection.vue?vue&type=script&lang=js"
import style0 from "./OfSelection.vue?vue&type=style&index=0&id=325aa0f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325aa0f2",
  null
  
)

export default component.exports